export const keepUnusedDataFor = 60 * 5;
export const isDev = process.env.NODE_ENV === 'development';
export const API_URI = isDev ? 'http://localhost:3001/' : 'https://api.eaglecapital.finance/';
